module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Home-277f15773f62df0616995dfabbac8a8e02343f4e646c3b6c4de7562f166150a5.svg";